export const GET_DOCU_LIST_LOADING = "GET_DOCU_LIST_LOADING";
export const GET_DOCU_LIST_SUCCESS = "GET_DOCU_LIST_SUCCESS";
export const GET_DOCU_LIST_FAILURE = "GET_DOCU_LIST_FAILURE";

export const ADD_DOCUMENT_LOADING = "ADD_DOCUMENT_LOADING";
export const ADD_DOCUMENT_SUCCESS = "ADD_DOCUMENT_SUCCESS";
export const ADD_DOCUMENT_FAILURE = "ADD_DOCUMENT_FAILURE";
